export function phoneRegex () {
  return /^((03)|(05)|(07)|(08)|(09))[0-9]{8}$/i
}
export function userNameRegex () {
  return /^(?=[a-zA-Z0-9._]{4,50}$)(?!.*[_.]{2})[^_.].*[^_.]$/
}
export function passwordRegex () {
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
}
export function fullNameRegex () {
  return /^[^\s]+[\s]+.*[^\s]+$/
}

export function phoneWithoutZeroRegex () {
  return /^[1-9][0-9]*$/
  // return /^[1-9]+[0-9]{8}$/i
}

export function checkOnlyTypeNumber () {
  return /^\d+$/
}

export function checkFilePDF(documentUrl) {
  return (/\.pdf$/).test(documentUrl)
}

export function checkFileVideo(url) {
  return (/\.(mp4|m4s|m4v|m4a|mov|MOV|Mov)$/i).test(url)
}

export function checkFileAudio(url) {
  return (/\.(?:wav|mp3)$/i).test(url)
}

export function checkDecimalPartIsZeroOrFive(number) {
  return (/^[0-9]+(\.[05])?$/).test(number)
}

export function checkFileUrl(url) {
  return (/^(http|https):\/\/[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,3}(\/\S*)?$/).test(url)
}

export function emailRegex() {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
}

export function isOnlyWhitespace () {
  return /^\s+$/
}

export function getDecimalRegex(number) {
  return (/^\d+([.,]\d{0,2})?$/).test(number)
}

export function formatPhone (phone) {
  phone = String(phone).trim()
  const regex = /^0\d{8,9}$/
  return regex.test(phone) ? phone : '0' + phone
}

export function linkRegex(link) {
  return /^(ftp|http|https):\/\/[^ "]+$/g.test(link)
}